import React from 'react';
import { translate } from 'react-i18next';

import {Button, Form, Input, Grid, Header, Message, Label, Segment, Modal, Checkbox, Dropdown, Icon} from 'semantic-ui-react';

import {colors} from 'style';

var style = {
    container: {
        padding: '10px 5px 10px 5px',
    },
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        float:'right',
        color: colors.themeBlue,
    },
    levelRowClickable: {
        cursor: 'pointer',
    }
}


const EditLevel = ({t, levels, onClose, onSubmit}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header>{t('Level')}</Modal.Header>
        <Modal.Content>
            {levels.map(level=>(
                <div style={(level.locked || level.active) ? {} : style.levelRowClickable} 
                     className="clearfix" 
                     key={level.key} 
                     onClick={()=>{!(level.locked || level.active) && onSubmit(level.value)}}>
                    {t('Level_{{value}}', {value:level.value})}
                    <div style={style.contentDiv}>
                        {Boolean(level.locked || level.active) &&
                            <Icon className={level.locked ? 'icon-lock' : 'icon-check'} />
                        }
                    </div>
                    <hr />
                </div>
            ))}
        </Modal.Content>
      </Modal>
  );

export default translate('categories')(EditLevel);



// WEBPACK FOOTER //
// ./src/modules/categories/EditLevel.js